import Vue from 'vue';
import CKEditor from '@ckeditor/ckeditor5-vue'
import '@ckeditor/ckeditor5-build-classic/build/translations/ru';

Vue.use( CKEditor );

